import $ from 'jquery';
import { Extension } from '@tiptap/core';

const ToggleMessageControls = Extension.create({
  name: 'toggleHiddenControls',

  onUpdate({ editor }) {
    const show = showEditorControls(editor);
    const container = $(editor.view.dom).closest('form');

    toggleHiddenControls(container, show);
    toggleDisabledButtons(container, show);
  },
});

const showEditorControls = (editor) => {
  const content = editor.getHTML().trim();
  const emptyParagraph = /^<p>\s*<\/p>$/;

  return content.length > 0 && !emptyParagraph.test(content);
};

const toggleHiddenControls = (container, show) => {
  const hiddenControls = container.find('[data-js-hidden-control]');

  if (hiddenControls.length) {
    hiddenControls.toggle(show);
  }
};

const toggleDisabledButtons = (container, show) => {
  const disabledButtons = container.find('button[data-js-disabled-control]');

  if (disabledButtons.length) {
    disabledButtons.toggleClass('button-disabled', !show);
    if (show) {
      disabledButtons.removeAttr('disabled');
    } else {
      disabledButtons.attr('disabled', 'disabled');
    }
  }
};

export default [ToggleMessageControls];
